<template>
  <div class="mit-reserve-now"><!-- default all to 1 but override sm and larger to 8 -->
    <!-- ********   MOBILE VIEW ******** -->
    <v-sheet v-if="isMobile" style="overflow-x: auto;overflow-y: hidden;">
            <div flat class="pt-3" >
                <v-btn class="mr-2" outlined color="grey darken-2" @click="setToday">Today</v-btn>
                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      outlined
                      color="grey darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="changedType('day')">
                      <v-list-item-title>Day</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changedType('week')">
                      <v-list-item-title>Week</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changedType('month')">
                      <v-list-item-title>Month</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu> 
              </div>
              <v-toolbar flat class="" >
                <v-btn fab text small color="grey darken-4" @click="prev"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title class="pl-10 pr-10">{{ calendarTitle }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn fab text small color="grey darken-4" @click="next"><v-icon>mdi-chevron-right</v-icon></v-btn>
            </v-toolbar>
      </v-sheet>
       <!-- ********  DESKTOP VIEW ******** -->
      <v-sheet v-else height="54" style="overflow-x: auto;overflow-y: hidden;">
            <v-toolbar flat class="" >
                <v-btn class="mr-2" outlined color="grey darken-2" @click="setToday">Today</v-btn>
                <v-menu bottom right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      outlined
                      color="grey darken-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <span>{{ typeToLabel[type] }}</span>
                      <v-icon right>
                        mdi-menu-down
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="changedType('day')">
                      <v-list-item-title>Day</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changedType('week')">
                      <v-list-item-title>Week</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="changedType('month')">
                      <v-list-item-title>Month</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-spacer></v-spacer>
                <v-btn class="ml-50" fab text small color="grey darken-4" @click="prev"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-toolbar-title class="pl-10 pr-10">{{ calendarTitle }}</v-toolbar-title>
                <v-btn fab text small color="grey darken-4" @click="next"><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-spacer></v-spacer>
                
            </v-toolbar>
      </v-sheet>
      <v-sheet height="80vh" style="overflow-x: auto;overflow-y: hidden;">
        <!-- 'stack', 'column' -->
        <v-calendar
          class="mt-3 mit-calendar"
          ref="cal"
          :style="(isMobile && (type == 'month' || type == 'week') ) ? 'min-width:1000px' : ''"
          v-model="calendarValue"
          :weekdays="[0, 1, 2, 3, 4, 5, 6]"
          :type="type"
          :event-more="true"
          :events="calendarReservations"
          :event-overlap-mode="'stack'"
          @click:event="clickedEvent"
          @click:more="clickedMore"
          @change="calendarDateChanged"
        >
          <template v-slot:event="{ event }">
            <!-- <span><b>{{ event.reservationModel.startTime1 }}</b>,{{ ' '+ event.reservationModel.name }} </span> -->
            <div class="pl-2" v-if="type === 'month'">
              <div class="black--text" :class="event.reservationModel.expired ? 'expired' : ''"><b>{{ event.reservationModel.startTime1 }}</b>,{{ ' '+ event.reservationModel.name }} </div>
            </div>
            <div class="pl-2" v-if="type === 'week'">
              <div  class="black--text text-truncate" :class="event.reservationModel.expired ? 'expired' : ''"><b>{{ event.reservationModel.startTime1 }}</b>, {{ event.reservationModel.name }}</div>
              <div class="black--text"><b>Owner:</b> {{event.reservationModel.owner }}</div>
            </div>
            <div class="pl-2" v-if="type === 'day'">
              <div class="black--text" :class="event.reservationModel.expired ? 'expired' : ''"><b>{{ event.reservationModel.startTime1 }} - {{ event.reservationModel.endTime1 }}</b>, {{ event.reservationModel.name }}</div>
              <div class="black--text"><b>Owner:</b> {{event.reservationModel.owner }}</div>
            </div>
          </template>
        </v-calendar>
      </v-sheet>
  </div>
</template>

<script>
  import moment from 'moment';

export default {
  name: 'BaseMitMyReservationCalendar',
  components: {
  },
  props: {
    reservations:{
          default () {
              return [];
          },
          type: Array
      },
      user:{
          default () {
              return null;
          },
          type: Object
      },
      focusTime:{
          default () {
              return moment().format('hh:mm A');
          },
          type: String
      },
      calendarDate:{
          default () {
              return moment();
          },
          type: Object
      },
      calendarColors:{
        default(){
          return {}
        },
        type:Object
      }
  },
  data: function() {
    return {
      calendarReservations:[],
      value: '',
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
      },
      userId:null,
      calendarTitle:'',
      calendarValue:null
    }
  },
  watch: {
      reservations(newVal, oldVal) {
        this.setExistingReservationsInCalendar(this.reservations);
      },
      focusTime(newVal, oldVal) {
          this.time = moment(newVal, 'hh:mm A');
          this.setFocusTime(this.time)
      },
      calendarDate(newVal, oldVal) {
          this.calendarValue = moment(newVal).toDate();
      }
  },
  created(){
    this.calendarValue = moment(this.calendarDate).toDate();
  },
  computed: {
      cal () {
        return this.mounted ? this.$refs.cal : null
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm';
      }
  },
  mounted() {
      this.mounted = true;
      this.time = moment(this.focusTime, 'hh:mm A');
      this.setFocusTime(this.time);
      this.calendarTitle = this.cal.title;
      this.userId = this.user.csailId;
  },
  methods : {
    calendarDateChanged(eventData){

      this.$emit('dateChanged', 
      {
          start:moment(eventData.start.date,'YYYY-MM-DD').startOf('day'),
          end:moment(eventData.end.date,'YYYY-MM-DD').endOf('day')
      });
    },
    setToday () {
        this.calendarValue = moment().toDate();

        this.$nextTick(() => {
          this.calendarTitle = this.cal.title;
        });
      },
      prev () {
        //this.cal.prev();
        switch(this.type){
          case 'day':
            this.calendarValue = moment(this.calendarValue).subtract(1, 'days').toDate();
            break;
          case 'week':
            this.calendarValue = moment(this.calendarValue).subtract(1, 'weeks').toDate();
            break;
          case 'month':
            this.calendarValue = moment(this.calendarValue).subtract(1, 'months').toDate();
            break;
        }
        this.$nextTick(() => {
          this.calendarTitle = this.cal.title;
        });
      },
      next () {
        switch(this.type){
          case 'day':
            this.calendarValue = moment(this.calendarValue).add(1, 'days').toDate();
            break;
          case 'week':
            this.calendarValue = moment(this.calendarValue).add(1, 'weeks').toDate();
            break;
          case 'month':
            this.calendarValue = moment(this.calendarValue).add(1, 'months').toDate();
            break;
        }
        
        //this.cal.next();
        this.$nextTick(() => {
          this.calendarTitle = this.cal.title;
        });
      },
    // todayClicked(){
    //   this.calendarValue = moment().toDate();
    // },
    clickedMore ({ date }) {
        this.calendarValue = date
        this.changedType('day');
    },
    changedType(type){
      this.type = type;
        this.$nextTick(() => {
          this.setFocusTime(this.time);
        });
    },
    setFocusTime (momentTime) {
        this.cal.scrollToTime(momentTime.format("HH:mm"));//24 hour time
    },
    setExistingReservationsInCalendar(reservations ){
          //clear the array while maintaining its address in memory since its passed to the calendar component and used.
          this.calendarReservations.splice(0, this.calendarReservations.length);
          let color = 'primary';

          for(let x = 0; x < reservations.length; x++){

            // if(reservations[x].expired){
            //   color = this.calendarColors.event;
            // }
            // else if(reservations[x].owner === this.userId){
            //   color = this.calendarColors.myEvent;
            // }
            if(reservations[x].owner === this.userId){
              color = this.calendarColors.myEvent;
            }
            else{
              color = this.calendarColors.mySecondaryEvent;
            }

            this.calendarReservations.push({
                name: reservations[x].mitId + ' ' + reservations[x].name,
                start: reservations[x].startDateTime.toDate(),
                end: reservations[x].endDateTime.toDate(),
                color: color,
                timed: true,
                reservationModel:reservations[x]
            })
          }
    },
    clickedEvent (calEvent) {
      this.$emit('clicked-event', calEvent.event.reservationModel);
    }


  }
}
</script>

<style lang="scss" scoped>
  .expired {
    text-decoration: line-through;
  }
  // .mit-calendar >>>.v-calendar-weekly {
  //   display: grid;
  //   table-layout: fixed;
  // }
  // .mit-calendar >>>.v-calendar-weekly__week {
  //   height: auto;
  //   display: table-row;
  // }
  // .mit-calendar >>>.v-calendar-weekly__day {
  //   display: table-cell;
  //   width: calc(100% / 7)
  // }
  // .mit-calendar >>>.v-calendar-weekly__day {
  //   overflow-y: auto;
  // }
  // .mit-calendar >>>.v-calendar-weekly__head {
  //   height: auto;
  //   display: table-row;
  // }

  // .mit-calendar >>>.v-calendar-weekly__head-weekday {
  //   display: table-cell;
  //   width: calc(100% / 7)
  // }
  // ::v-deep .v-date-picker-header__value{
    //     font-size: 23px;
    // }
    // ::v-deep .v-date-picker-header{
    //     .v-date-picker-header__value{
    //         font-size: 20px;
    //     }
    //     // .v-icon{
    //     //     font-size:30px !important;
    //     // }
        
    // }
</style>
